import React from 'react';
import NoSSR from 'react-no-ssr';
import MediaQuery from 'react-responsive';

import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';

import {
  MQ_DESKTOP_MIN_WIDTH,
  MQ_TABLET_MIN_WIDTH,
  MQ_TABLET_MAX_WIDTH,
  MQ_MOBILE_MAX_WIDTH
} from '@spotahome/landings-common/src/constants';

import './AboutBuild.scss';

const AboutBuild = () => (
  <section className="about-build">
    <NoSSR>
      <MediaQuery minWidth={MQ_DESKTOP_MIN_WIDTH}>
        <figure className="about-build__figure">
          <img
            alt="South summit"
            src={getResourcePath('/images/about-us/desktop-south-summit.jpg')}
          />
        </figure>
      </MediaQuery>
    </NoSSR>

    <NoSSR>
      <MediaQuery minWidth={MQ_TABLET_MIN_WIDTH} maxWidth={MQ_TABLET_MAX_WIDTH}>
        <figure className="about-build__figure">
          <img
            alt="South summit"
            src={getResourcePath('/images/about-us/tablet-south-summit.jpg')}
          />
        </figure>
      </MediaQuery>
    </NoSSR>

    <NoSSR>
      <MediaQuery maxWidth={MQ_MOBILE_MAX_WIDTH}>
        <figure className="about-build__figure">
          <img
            alt="South summit"
            src={getResourcePath('/images/about-us/mobile-south-summit.jpg')}
          />
        </figure>
      </MediaQuery>
    </NoSSR>

    <div className="about-build__container">
      <Heading
        size="large"
        theme="dark"
        text={trans('about-us.build.title')}
        className="mb-xl"
      />
      <p className="mb-xl">{trans('about-us.build.paragraph-1')}</p>
      <div
        dangerouslySetInnerHTML={{
          __html: trans('about-us.build.paragraph-2')
        }}
      />
    </div>
  </section>
);

export default AboutBuild;
